import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ArrayOperationService {

  public delete<T>(item: T, list: T[], unfilteredList: T[]): void {
    let index = list.indexOf(item);
    if (index >= 0) {
      list.splice(index, 1);
    }

    index = unfilteredList.indexOf(item);
    if (index >= 0) {
      unfilteredList.splice(index, 1);
    }
  }

  public deleteItem<T>(item: T, list: T[], property: string): void {
    const listIndex = this.getItemIndex(list, property, item[property]);
    if (listIndex >= 0) {
      list.splice(listIndex, 1);
    }
  }

  public removeStringFromArray(item: string, list: string[]): void {
    const index = list.indexOf(item);
    if (index >= 0) {
      list.splice(index, 1);
    }
  }

  public update<T>(item: T, list: T[], unfilteredList: T[], propertyName: string = 'id'): void {
    const listIndex = this.getItemIndex(list, propertyName, item[propertyName]);
    const unfilteredListIndex = this.getItemIndex(unfilteredList, propertyName, item[propertyName]);

    if (listIndex >= 0) {
      list[listIndex] = item;
    }

    if (unfilteredListIndex >= 0) {
      unfilteredList[unfilteredListIndex] = item;
    }
  }

  public updateItem<T>(item: T, list: T[]): void {
    const listIndex = this.getItemIndex(list, 'id', item['id']);

    if (listIndex >= 0) {
      list[listIndex] = item;
    }
  }

  public exists<T>(item: T, list: T[], property: string): boolean {
    const listIndex = this.getItemIndex(list, property, item[property]);
    return listIndex >= 0;
  }

  public itemExists<T>(item: T, list: T[]): boolean {
    let itemFound = false;
    if (item !== null && item !== undefined && list !== null) {
      const properties = Object.keys(item);

      list.forEach(listItem => {
        let match = true;
        properties.forEach(property => {
          if (listItem[property] !== item[property]) {
            match = false;
          }
        });
        if (match) {
          itemFound = true;
        }
      });
    }
    return itemFound;
  }

  public getItemIndex(list: any[], property: string, searchedId: number | string) {
    let listIndex = -1;
    list.forEach((u, index) => {
      if (u[property] === searchedId) {
        listIndex = index;
      }
    });
    return listIndex;
  }

  public arraysAreIdentical(array1: any[], array2: any[]): boolean {
    const objectsEqual = (o1, o2) =>
        Object.keys(o1).length === Object.keys(o2).length
        && Object.keys(o1).every(p => o1[p] === o2[p]);
    return array1.length === array2.length && array1.every((o, idx) => objectsEqual(o, array2[idx]));
  }

}
